import { getLoginName } from '@/utils/util'

export const BILL_TYPE = 'BATCH_STOCK'
export const REPORT_TITLE = '批次库存统计'

export const defColumns = [
  {
    title: '序号', dataIndex: 'rowIndex', width: 50, align: 'center',
    customRender: function(t, r, index) {
      return (t !== '合计') ? (parseInt(index) + 1) : t
    }
  },
  {
    title: '库存流水', dataIndex: 'action', width: 80, align: 'center',
    scopedSlots: { customRender: 'actionCustomRender' }
  },
  { title: '条码', dataIndex: 'materialCode', width: 120, ellipsis: true },
  { title: '名称', dataIndex: 'materialName', width: 150, ellipsis: true },
  { title: '规格', dataIndex: 'materialStandard', width: 80, ellipsis: true },
  { title: '型号', dataIndex: 'materialModel', width: 80, ellipsis: true },
  { title: '类别', dataIndex: 'categoryName', width: 80, ellipsis: true },
  { title: '单位', dataIndex: 'materialUnit', width: 50 },
  { title: '批号', dataIndex: 'batchNumber', width: 80, ellipsis: true },
  { title: '有效日期', dataIndex: 'expirationDateStr', width: 100, ellipsis: true },
  { title: '扩展信息', dataIndex: 'expand', width: 100, ellipsis: true },
  { title: '成本价', dataIndex: 'purchaseDecimal', width: 80, align: 'right' },
  { title: '批次库存', dataIndex: 'totalNum', width: 90, align: 'right' },
  { title: '库存金额', dataIndex: 'totalPrice', width: 90, align: 'right' }
]

export function buildPrintData(dataSource, queryParam, userInfo, companyInfo) {
  const totalRow = (dataSource || []).find(item => item.rowIndex === '合计')
  const rows = (dataSource || [])
    .filter(item => item.rowIndex !== '合计')
    .map((item, idx) => ({
      rowIndex: idx + 1,
      materialCode: item.materialCode || '',
      materialName: item.materialName || '',
      materialStandard: item.materialStandard || '',
      materialModel: item.materialModel || '',
      categoryName: item.categoryName || '',
      materialUnit: item.materialUnit || '',
      batchNumber: item.batchNumber || '',
      expirationDateStr: item.expirationDateStr || '',
      expand: item.expand || '',
      purchaseDecimal: item.purchaseDecimal || 0,
      totalNum: item.totalNum || 0,
      totalPrice: item.totalPrice || 0
    }))
  if (totalRow) {
    rows.push({
      rowIndex: '合计',
      materialCode: '', materialName: '', materialStandard: '', materialModel: '',
      categoryName: '', materialUnit: '', batchNumber: '', expirationDateStr: '', expand: '',
      purchaseDecimal: '-',
      totalNum: totalRow.totalNum || 0,
      totalPrice: totalRow.totalPrice || 0
    })
  }
  return {
    reportTitle: REPORT_TITLE,
    reportDate: new Date().toLocaleDateString(),
    dateRange: '',
    table: rows,
    total_totalNum: 0,
    total_totalPrice: 0,
    creatorName: getLoginName(),
    companyName: (companyInfo && companyInfo.companyName) || '',
    companyAddress: (companyInfo && companyInfo.companyAddress) || '',
    companyTel: (companyInfo && companyInfo.companyTel) || '',
    companyFax: (companyInfo && companyInfo.companyFax) || ''
  }
}